import React from "react";
import PropTypes from "prop-types";
import classNames from "classnames";
import CreativeTemplatePropType from "common/prop-types/creative-template-prop-type";
import NewsFeedItem from "./news-feed-item";
import CreatomateAdPreview from "./creatomate-ad-preview";
import newsfeedPersonPlaceholderImage from "../../../assets/images/ad_preview/newsfeed-person.jpg";
import newsfeedPlaceholderImage from "../../../assets/images/ad_preview/house-newsfeed.jpg";
import "./phone-placeholder.styles.scss";

const propTypes = {
  creative: CreativeTemplatePropType.isRequired,
  facebookPage: PropTypes.shape({
    name: PropTypes.string,
    picture: PropTypes.string
  }).isRequired,
  facebookNewsfeedData: PropTypes.shape({
    body: PropTypes.string,
    title: PropTypes.string,
    message: PropTypes.string,
    domain: PropTypes.string
  }).isRequired,
  isMobile: PropTypes.bool,
  uniqueKey: PropTypes.string.isRequired
};

const FacebookPhonePlaceholder = ({
  creative,
  facebookPage,
  facebookNewsfeedData,
  isMobile = false,
  uniqueKey
}) => {
  const MAX_WIDTH = 378;
  const MEDIA_MAX_HEIGHT = 680;
  const reductionRate = MAX_WIDTH / creative.width;
  const creativeHeight = Math.min(creative.height * reductionRate, MEDIA_MAX_HEIGHT);

  return (
    <div className="py-4">
      <div
        className={classNames([
          "ad-preview__iphone-placeholder",
          { "ad-preview__iphone-placeholder--mobile": isMobile }
        ])}
      >
        <div className="ad-preview__iphone-placeholder-container">
          <NewsFeedItem
            pageIcon={facebookPage.picture}
            pageName={facebookPage.name}
            title={facebookNewsfeedData.title}
            domain={facebookNewsfeedData.domain}
            message={facebookNewsfeedData.message}
            body={facebookNewsfeedData.body}
            mediaSrc={`${creative.previewPath}?ts=${new Date().getTime()}`}
            isVideo={creative.primaryMimeType === "video/mp4"}
          >
            {creative.isCreatomateTemplate && (
              <CreatomateAdPreview
                key={uniqueKey}
                creative={creative}
                width={MAX_WIDTH}
                height={creativeHeight}
              />
            )}
          </NewsFeedItem>
          <NewsFeedItem
            pageIcon={newsfeedPersonPlaceholderImage}
            pageName="Some Page"
            title="Your title goes here"
            subtitle="15m ago"
            domain="www.adwerx.com"
            body="Body goes here"
            message="Message goes here"
            mediaSrc={newsfeedPlaceholderImage}
            isBlurred
          />
        </div>
      </div>
      <small className="pt-3">
        Ad rendering and interaction may vary based on device, format and other factors.
      </small>
    </div>
  );
};

FacebookPhonePlaceholder.propTypes = propTypes;

export default FacebookPhonePlaceholder;
